import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

let context = null;

export const getTokenContext = () => {
  if (context === null) {
    throw new Error("Auth0 token context not initialized");
  }

  return context;
};

export const Auth0SDKBridge = () => {
  const { getAccessTokenSilently, logout } = useAuth0();

  useEffect(() => {
    context = {
      getAccessTokenSilently,
      logout,
    };

    return () => {
      context = null;
    };
  }, [getAccessTokenSilently, logout]);

  return null;
};